import { render, staticRenderFns } from "./EmployeeFiles.vue?vue&type=template&id=6ed09850&scoped=true"
import script from "./EmployeeFiles.vue?vue&type=script&lang=js"
export * from "./EmployeeFiles.vue?vue&type=script&lang=js"
import style0 from "./EmployeeFiles.vue?vue&type=style&index=0&id=6ed09850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed09850",
  null
  
)

export default component.exports